import React from "react";
import JobsList from "@/components/JobsList";
import TechniciansList from "@/components/TechniciansList";
import AddTechnicianDialog from "@/components/AddTechnicianDialog";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

const Index = () => {
  const [addOpen, setAddOpen] = React.useState(false);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-full py-12 px-2 bg-gradient-to-t from-slate-50 via-white to-teal-50 animate-fadein">
      <div className="mb-12 text-center">
        <h1 className="text-3xl md:text-5xl font-bold text-slate-900 tracking-tight mb-3">
          FTTx Field Service Manager
        </h1>
        <p className="text-lg text-slate-600 max-w-xl mx-auto">
          End-to-end management for fiber installation & maintenance teams.<br className="hidden md:inline" />
          Realtime job tracking, schedule, and technician dashboard.
        </p>
      </div>
      <div className="w-full max-w-3xl">
        <JobsList />
      </div>
      <div className="w-full max-w-5xl">
        <div className="flex items-center justify-center gap-4 mt-16 mb-6">
          <h2 className="text-2xl font-semibold text-slate-900">Active Technicians</h2>
          <Button size="sm" onClick={() => setAddOpen(true)}>
            <Plus className="h-4 w-4 mr-1" /> Add Technician
          </Button>
        </div>
        <TechniciansList />
      </div>
      <AddTechnicianDialog open={addOpen} onOpenChange={setAddOpen} />
    </div>
  );
};

export default Index;